// @flow

export function compareBankOptionsOrder(a: string, b: string): number {
  return getBankOrder(a) - getBankOrder(b);
}

function getBankOrder(code: string): number {
  switch (code) {
    case 'rapipago':
      return 0;
    case 'pagofacil':
      return 1;
    default:
      return 100;
  }
}
